module.exports = __webpack_public_path__ + "media/images/home/boxes/smart_calendar-2d971185a538fef9a5ae1c09f54a514d.svg";